import React, {Component} from 'react';
import {connect} from 'react-redux';
import './SettingsPane.scss';
import actions from '../../store/actions';
import DeviceSettingsTab from './views/DeviceSettingsTab/DeviceSettingsTab';
import CommandHistoryTab from './views/CommandHistoryTab/CommandHistoryTab';

class SettingsPane extends Component { 
    config = {
        DeviceSettingsTab:{
            key:'DeviceSettingsTab',
            title: 'Device Settings',
        },
        CommandHistoryTab:{
            key:'CommandHistoryTab',
            title: 'Command History',
        },
    };
    state = {
        ver: 0
    }
    componentDidMount() {
        this.props.dispatch({
            type:actions.SETTINGS_PANE_TAB_CHANGED,
            data:this.config[Object.keys(this.config)[0]]
        })
    }
    componentWillReceiveProps(props) {
        if(props.settingsPane.active && !this.props.settingsPane.active) {
            if(props.settingsPane.active) {
                document.title = "Track - Device Setting / Command History"
            }
            this.setState({ver:this.state.ver + 1});
        }
    }
    renderTab() {
        let key = this.props.settingsPane && this.props.settingsPane.tab ? this.props.settingsPane.tab.key : null;
        let active = this.props.settingsPane && this.props.settingsPane.active;
        switch(key) {
            case this.config.DeviceSettingsTab.key:
                return <DeviceSettingsTab ver={this.state.ver} />;
            case this.config.CommandHistoryTab.key:
                return <CommandHistoryTab ver={this.state.ver} isSettingsPaneActive={active}/>;
            default:
                return null;
        }
    }

    changeTab = (tab) => {
        return () => {
            this.props.dispatch({
                type:actions.SETTINGS_PANE_TAB_CHANGED,
                data:this.config[tab]
            });
            setTimeout(() => this.setState({ver:this.state.ver + 1}), 50);
        }
    }
    
    render() {
        let tabs = Object.keys(this.config);
        let active = this.props.settingsPane && this.props.settingsPane.active;
        let curTab = this.props.settingsPane && this.props.settingsPane.tab ? this.props.settingsPane.tab.key : null;
        return (
            <div className={'SettingsPane' + (active ? ' open' : '')}>
                <div className="sp-tabs">
                    {tabs.map(t => <button onClick={this.changeTab(t)} key={t} className={t == curTab ? 'active' : ''}>{this.config[t].title}</button>)}
                </div>
                <div className="sp-tabv">{this.renderTab()}</div>
            </div>
        )
    }
}


const mapPropsToState = state => {
    return {
        settingsPane:state.settingsPane,
    }
};

export default connect(mapPropsToState)(SettingsPane);